import { ageInMonthsFromDate, getAgeFromDate } from "./dateValidaton";

import { birthdayFrom } from "@storebrand-digital/storebrand-common-validation";

export const ageFromNin = (nin: string): number | undefined => {
  return getAgeFromDate(birthdayFrom(nin));
};

export const ageInMonthsFromNin = (nin?: string): number | undefined => {
  return ageInMonthsFromDate(birthdayFrom(nin));
};
